<template>
    <div class="homePage largeContent">
        <i class="close_btn el-icon-circle-close" v-show="0" @click="goBack"></i>
        <div class="homeTab">
            <btn-groups :currentBtnType="1" @switchType="switchType"></btn-groups>
            <div class="homeTitle">OBD运营数据大屏</div>
            <div class="auxiliaryScreen clearfix">
                <div class="dimension">统计周期【上周】</div>
                <i class="el-icon-s-operation closeBtn" @click="goBack"></i>
            </div>
        </div>
        <el-row class="layRow">
            <el-col class="layCol" :span="6">
                <div class="chart_left">
                    <!-- 左1 -->
                    <div class="module_wrap chartBoxBorder left0">
                        <div class="borderTop">百公里三急一超<span class="miniTitle">（前5）</span></div>
                        <div id="chart_line" class="wrapChart" v-show="!chartLeftNoData0" v-loading="chartLeftLoading0"></div>
                        <div class="null_data_chart" v-show="chartLeftNoData0">暂无数据</div>
                    </div>
                    <!-- 左2 -->
                    <div class="module_wrap chartBoxBorder left1" v-loading="chartLeftLoading1">
                        <div class="borderTop">
                            <b>车队日均驾驶时长<span class="miniTitle">（前5）</span></b>
                            <span class="more" @click="hrefInfoPage(0)"
                                >更多
                                <i class="el-icon-arrow-right moreBtn"></i>
                            </span>
                        </div>
                        <div id="chart_top" class="wrapChart" v-show="!chartLeftNoData1">
                            <el-row v-for="(item, index) in drivingDuration" :key="index">
                                <el-col :span="2" :offset="1">
                                    <div :class="{ medalHot: 1, ['medalHot' + (index + 1)]: 1 }">
                                        {{ index + 1 }}
                                    </div>
                                </el-col>
                                <el-col class="fleetName" :span="6">
                                    <overflow-txt :txt="item.name"></overflow-txt>
                                </el-col>
                                <el-col :span="12" :offset="1">
                                    <div class="progressContainer">
                                        <div class="progressBar" :style="`width:${item.ratio * 100}%`"></div>
                                    </div>
                                </el-col>
                                <el-col class="fleetDuration" :span="3" :offset="1">{{ item.duration }}</el-col>
                            </el-row>
                        </div>
                        <div v-show="chartLeftNoData1" class="null_data_chart">暂无数据</div>
                    </div>
                    <!-- 左3 -->
                    <div class="module_wrap left2 hideChart">
                        <div class="borderTop">单程驾驶时长<span class="miniTitle">（前5）</span></div>
                        <el-row class="timeTop5 wrapChart"> </el-row>
                    </div>
                </div>
            </el-col>
            <el-col class="layCol centerLayCol" :span="12">
                <ul class="mapBtnGroups clearfix">
                    <li :class="{ activeLi: activeIndex == index }" v-for="(item, index) in btnData" :key="index" @click="mapBtnClick(index, item)">{{ item.label }}</li>
                </ul>
                <!-- 热力地图 -->
                <china-map ref="chinaMapRef" :chinaMapLoading="chinaMapLoading" :provinceValData="provinceValData" :cityData="currentTenantArea" :tooltipData="tooltipData" :heatCityData="heatCityData" :devicePixelRatio="devicePixelRatio"></china-map>
            </el-col>
            <el-col class="layCol" :span="6">
                <div class="chart_right">
                    <!-- 右1 -->
                    <div class="module_wrap chartBoxBorder right0">
                        <div class="borderTop">租户离线情况</div>
                        <div id="chartRightLine" class="wrapChart" v-show="!chartRightNoData0" v-loading="chartRightLoading0"></div>
                        <div class="null_data_chart" v-show="chartRightNoData0">暂无数据</div>
                    </div>
                    <!-- 右2 -->
                    <div class="module_wrap chartBoxBorder right1" v-loading="chartLeftLoading1">
                        <div class="borderTop">
                            <b>车辆日均驾驶时长<span class="miniTitle">（前5）</span></b>
                            <span class="more" @click="hrefInfoPage(2)"
                                >更多
                                <i class="el-icon-arrow-right moreBtn"></i>
                            </span>
                        </div>
                        <div id="chart_top" class="wrapChart" v-show="!chartLeftNoData1">
                            <el-row v-for="(item, index) in carDrivingDuration" :key="index">
                                <el-col :span="2" :offset="1">
                                    <div :class="{ medalHot: 1, ['medalHot' + (index + 1)]: 1 }">
                                        {{ index + 1 }}
                                    </div>
                                </el-col>
                                <el-col class="fleetName" :span="6">
                                    <overflow-txt :txt="item.plateNo"></overflow-txt>
                                </el-col>
                                <el-col :span="12" :offset="1">
                                    <div class="progressContainer">
                                        <div class="progressBar" :style="`width:${item.ratio * 100}%`"></div>
                                    </div>
                                </el-col>
                                <el-col class="fleetDuration" :span="3" :offset="1">{{ item.duration }}</el-col>
                            </el-row>
                        </div>
                        <div v-show="chartLeftNoData1" class="null_data_chart">暂无数据</div>
                    </div>
                    <!-- 右3 -->
                    <div class="module_wrap right2 hideChart">
                        <div class="borderTop">连续三天驾驶时长12h以上车辆</div>
                        <div class="day_table"></div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="bottomChart">
            <div class="leftBox module_wrap chartBoxBorder" v-loading="chartLeftLoading1">
                <div class="borderTop">
                    <b>车队运行率<span class="miniTitle">（前5）</span></b>
                    <span class="more" @click="hrefInfoPage(1)"
                        >更多
                        <i class="el-icon-arrow-right moreBtn"></i>
                    </span>
                </div>
                <div class="rankChart" v-show="!chartLeftNoData1">
                    <div class="dashboard" v-for="(item, index) in fleetAverageDailyMileageData" :key="index">
                        <div class="dashIcon">
                            <img :src="getImagePath(index, 1)" />
                            <div class="titleBox autoP">
                                <div class="dashTitle">{{ String(item.usageRate) == 'null' ? '--' : item.usageRate + '%' }}</div>
                                <!-- <div class="dashSubTitle">辆</div> -->
                            </div>
                        </div>
                        <div class="dashBottom">
                            <overflow-txt :txt="item.label"></overflow-txt>
                        </div>
                    </div>
                </div>
                <div v-show="chartLeftNoData1" class="null_data_chart">暂无数据</div>
            </div>
            <div class="rightBox module_wrap chartBoxBorder" v-loading="chartRightLoading2">
                <div class="borderTop">
                    <b>车辆日均里程<span class="miniTitle">（前5）</span></b>
                    <span class="more" @click="hrefInfoPage(3)"
                        >更多
                        <i class="el-icon-arrow-right moreBtn"></i>
                    </span>
                </div>
                <div class="rankChart" v-show="!chartRightNoData2">
                    <div class="dashboard" v-for="(item, index) in dailyVehicleMileageData" :key="index">
                        <div class="dashIcon">
                            <img :src="getImagePath(index, 2)" />
                            <div class="titleBox autoP">
                                <div class="dashTitle">{{ String(item.avgMileage) == 'null' ? '--' : item.avgMileage }}</div>
                                <!-- <div class="dashSubTitle">辆</div> -->
                            </div>
                        </div>
                        <div class="dashBottom">
                            <overflow-txt :txt="item.plateNo"></overflow-txt>
                        </div>
                    </div>
                </div>
                <div v-show="chartRightNoData2" class="null_data_chart">暂无数据</div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import ChinaMap from '@/components/ChinaMap.vue';
import BtnGroups from '@/components/largeScreen/btnGroups.vue';
const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
const remToPx = (rem) => rem * rootFontSize;
export default {
    name: 'DualCamera',
    components: {
        ChinaMap,
        BtnGroups
    },
    data() {
        return {
            chinaMapLoading: false,
            chartLeft0: null,
            chartLeft1: null,
            chartLeft2: null,
            chartRight0: null,
            chartRight1: null,
            chartRight2: null,
            centerChart0: null,
            centerChart1: null,
            chartLeftLoading0: false,
            chartLeftLoading1: false,
            chartLeftLoading2: false,
            chartRightLoading0: false,
            chartRightLoading1: false,
            chartRightLoading2: false,
            chartLeftNoData0: false,
            chartLeftNoData1: false,
            chartLeftNoData2: false,
            chartRightNoData0: false,
            chartRightNoData1: false,
            chartRightNoData2: false,
            devicePixelRatio: 1,
            checkedMenu: { name: '首页', id: '1' },
            drivingScore: [],
            nowMonth: '',
            mapVisible: true,
            timer: null,
            nowDate: '', // 当前日期时间
            formatDateTimer: null,
            totalData: {
                linevehicle: '',
                totalhour: '',
                totalmile: 0,
                totalvehicle: ''
            },
            queryData: {
                deviceType: 0 // obd-0 双摄-1  单摄-2
            },
            heatMapDataType: 1, // 1:行程数 2:驾驶里程 3:驾驶时长
            btnData: [
                { label: '行程数', value: 1, unit: '条' },
                { label: '驾驶里程', value: 2, unit: '公里' },
                { label: '驾驶时长', value: 3, unit: '小时' }
            ],
            tooltipData: {
                label: '',
                unit: ''
            },
            activeIndex: 0,
            heatCityData: {},
            provinceValData: {},
            deviceeTypeObj: {
                0: 'OBD',
                1: '双摄',
                2: '单摄'
            },
            homeModuleData: {
                areaDist: [], // 区域驾驶情况分布
                cityAvgAlarm: [], // 城市平均3急1超数量排行
                cityAvgMile: [], // 城市平均里程排行
                cityAvgTime: [], // 城市平均驾驶时长排行
                cityScores: [], // 城市评分排行
                cityScores: [], // 车辆评分分布
                cityScores: [] // 出行时长分布
            },
            driveTimeTop: [],
            carMileageTop3: [],
            carMileageTop5: [],
            cityScores: [{}],
            scoreDist: [],
            drivingDuration: [],
            carDrivingDuration: [],
            dayDurationsHeader: [],
            dayDurations: [],
            fleetAverageDailyMileageData: [],
            dailyVehicleMileageData: []
        };
    },
    computed: {
        currentTenantArea() {
            return this.$store.state.common.currentTenantAreaData;
        }
    },
    mounted() {
        this.nowMonth = this.setMonth();
        this.devicePixelRatio = window.devicePixelRatio || 1;
        this.currentTime();
        window.addEventListener('resize', () => {
            this.devicePixelRatio = window.devicePixelRatio || 1;
            this.$nextTick(() => {
                this.chartLeft0 && this.chartLeft0.resize();
                this.chartRight0 && this.chartRight0.resize();
                this.centerChart0 && this.centerChart0.resize();
                this.centerChart1 && this.centerChart1.resize();
            });
        });

        setTimeout(() => {
            this.mapBtnClick(0, this.btnData[0]);
        }, 1000);

        this.getThreeUrgentOneOvertaking();
        this.getTenantDailyAvgDrivingDuration();
        this.getTenantDailyAvgDrivingMileage();

        this.getOfflineRateTenant();
        this.getVehiclesDailyAvgDrivingDuration();
        this.getVehiclesDailyAvgDrivingMileage();
    },
    methods: {
        hrefInfoPage(type) {
            let _path = '/vehicle/vehicleTrip';
            let queryData = {};
            switch (type) {
                case 0:
                    _path = '/analysis/vehicleAnalysis';
                    queryData = {
                        handleLookDetail: true,
                        hrefTypeStr: '11'
                    };
                    break;
                case 1:
                    _path = '/analysis/vehicleAnalysis';
                    queryData = {
                        handleLookDetail: true,
                        hrefTypeStr: '7'
                    };
                    break;
                case 2:
                    _path = '/analysis/vehicleAnalysis';
                    queryData = {
                        handleLookDetail: true,
                        hrefTypeStr: '3'
                    };
                    break;
                case 3:
                    _path = '/analysis/vehicleAnalysis';
                    queryData = {
                        handleLookDetail: true,
                        hrefTypeStr: '1'
                    };
                    break;
            }

            this.$router.push({
                path: _path,
                query: queryData
            });
        },
        getImagePath(index, typeStr) {
            index = index == 4 ? 3 : index;
            return `/images/home/bottom${typeStr == 1 ? 'Left' : 'Right'}${index}.png`;
        },
        mapBtnClick(index, btnItem) {
            this.activeIndex = index;
            this.heatMapDataType = btnItem.value;
            this.tooltipData = {
                label: btnItem.label,
                unit: btnItem.unit
            };
            this.getHeatMap();
        },
        // 热力图
        getHeatMap() {
            this.mapHeatLoading = true;
            let tmpAreaCode = this.currentTenantArea.areaCode || null;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/heatMap',
                data: { heatMapDataType: this.heatMapDataType, areaCode: tmpAreaCode, deviceType: this.queryData.deviceType }
            }).then((res) => {
                this.mapHeatLoading = false;
                if (res.code == 200) {
                    // 处理成 {城市名: 热度值} 结构
                    this.heatCityData = {};
                    let resHeatData = res.data;

                    // 按省份分组，累加heatMapDataVal
                    const provinceAggregatedData = resHeatData.reduce((acc, city) => {
                        // 以省份名称作为分组键（也可用provinceCode确保唯一性）
                        const key = tmpAreaCode ? city.cityName : city.provinceName;

                        if (!acc[key]) {
                            // 若该省份首次出现，初始化数据
                            acc[key] = {
                                provinceCode: tmpAreaCode ? city.cityCode : city.provinceCode,
                                provinceName: tmpAreaCode ? city.cityName : city.provinceName,
                                totalHeatMapDataVal: 0, // 累加值初始化
                                cities: [] // 存储下属城市数据（可选）
                            };
                        }

                        // 累加当前城市的heatMapDataVal到省份总数值
                        acc[key].totalHeatMapDataVal += city.heatMapDataVal;
                        // 可选：存储下属城市数据（便于后续展示城市列表）
                        acc[key].cities.push(city);

                        return acc;
                    }, {});

                    // 转换为数组形式（便于在ECharts中使用）
                    const provinceList = Object.values(provinceAggregatedData);

                    this.provinceValData = {};
                    provinceList.forEach((item) => {
                        if (!this.provinceValData[item.provinceName]) {
                            this.provinceValData[item.provinceName] = {
                                provinceName: item.provinceName,
                                totalHeatMapDataVal: Number.isInteger(item.totalHeatMapDataVal) ? item.totalHeatMapDataVal : item.totalHeatMapDataVal.toFixed(2)
                            };
                        }
                    });

                    // 遍历所有城市数据
                    resHeatData.forEach((cityItem) => {
                        // 提取城市名作为键，heatMapVal作为值
                        this.heatCityData[tmpAreaCode ? cityItem.cityName : cityItem.provinceName] = cityItem.heatMapDataVal;
                    });
                } else {
                    console.log('热力图获取失败');
                }
            });
        },
        // 三急一超
        getThreeUrgentOneOvertaking() {
            this.chartLeftLoading0 = true;
            this.chartLeftNoData0 = false;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/threeUrgentOneOvertaking',
                data: this.queryData
            }).then((res) => {
                this.chartLeftLoading0 = false;
                if (res.code == 200) {
                    const indicatorMap = [
                        { field: 'rapidAccelerationPer100kmCount', name: '急加速' },
                        { field: 'rapidDecelerationPer100kmCount', name: '急减速' },
                        { field: 'rapidTurnPer100kmCount', name: '急转弯' },
                        { field: 'overspeedPer100kmCount', name: '超速' }
                    ];

                    const colorMap = {
                        急加速: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#FF9000' },
                            { offset: 1, color: '#4B3710' }
                        ]),
                        急减速: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#00D5FF' },
                            { offset: 1, color: '#10274B' }
                        ]),
                        急转弯: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#D6D260' },
                            { offset: 1, color: '#3D3B02' }
                        ]),
                        超速: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#1978E5' },
                            { offset: 1, color: '#10274B' }
                        ])
                    };

                    let chartData = res.data;

                    if (chartData.length < 1) {
                        this.chartLeftNoData0 = true;
                        return;
                    }

                    let xAxisData = chartData.map((chart) => chart.tenantName);

                    let seriesData = indicatorMap.map((indicator) => {
                        // 从每个地区数据中提取当前指标的值
                        const data = chartData.map((chart) => chart[indicator.field]);
                        return {
                            name: indicator.name,
                            color: '',
                            data: data
                        };
                    });

                    this.loadChartsLeft0(xAxisData, seriesData, colorMap);
                } else {
                    this.chartLeftNoData0 = true;
                }
            });
        },
        loadChartsLeft0(xAxisData, seriesData, colorMap) {
            let chartDom = document.getElementById('chart_line');
            this.chartLeft0 = echarts.init(chartDom, null, { renderer: 'svg' });
            let option = {
                textStyle: {
                    fontFamily: 'PingFang Regular'
                },
                tooltip: {
                    trigger: 'axis',
                    // 关键配置：限制tooltip在图表容器内显示
                    confine: true,
                    // 自定义位置计算，确保左侧不超出屏幕
                    position: function (point, params, dom, rect, size) {
                        // point: 鼠标位置 [x, y]
                        // size: 包含tooltip宽高 {contentSize: [width, height], viewSize: [chartWidth, chartHeight]}

                        // 左侧最小距离（避免贴边）
                        const leftMin = 10;
                        // 计算tooltip的x坐标，确保不小于leftMin
                        let x = point[0];
                        // 如果当前位置过左，调整到左侧安全区域
                        if (x < size.contentSize[0] + leftMin) {
                            x = leftMin;
                        }
                        // 保持y坐标不变（也可根据需要调整上下位置）
                        return [x, point[1]];
                    },
                    // 可选：添加边框和背景色增强可见性
                    textStyle: {
                        color: '#fff',
                        fontSize: remToPx(0.14) // 将提示框内所有文字设置为白色
                    },
                    backgroundColor: 'rgba(8, 32, 69, 0.9)',
                    borderColor: '#1E90FF',
                    borderWidth: 1,
                    confine: true
                },
                legend: {
                    data: seriesData.map((s) => s.name),
                    textStyle: { color: '#fff', fontSize: remToPx(0.14) },
                    top: 10,
                    left: 'center',
                    orient: 'horizontal',
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 15
                },
                grid: {
                    top: '17%',
                    left: '13%',
                    right: '6%',
                    bottom: '20%'
                },
                xAxis: {
                    data: xAxisData,
                    axisLabel: {
                        color: '#fff',
                        rotate: 20, // 旋转角度（0-90），45度较常用
                        interval: 0,
                        fontSize: 10,
                        fontSize: remToPx(0.11),
                        formatter: function (value) {
                            const maxLength = 6; // 最多显示6个字符
                            return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
                        },
                        // 鼠标悬停时显示完整文本
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                return params.value; // 显示完整X轴文本
                            }
                        }
                    }
                },
                yAxis: {
                    name: '单位：次',
                    axisLabel: {
                        color: '#fff',
                        fontSize: remToPx(0.14)
                    },
                    nameTextStyle: {
                        color: '#fff',
                        fontSize: remToPx(0.14)
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#2C4A7B',
                            width: 1,
                            type: 'solid'
                        }
                    }
                },
                series: seriesData.map((s) => ({
                    type: 'bar',
                    barMaxWidth: 7,
                    barGap: '90%',
                    itemStyle: {
                        borderRadius: [20, 20, 0, 0],
                        color: colorMap[s.name]
                    },
                    ...s
                }))
            };
            this.chartLeft0.setOption(option);
        },
        // 车队日均驾驶时长top5
        getTenantDailyAvgDrivingDuration() {
            this.chartLeftLoading1 = true;
            this.chartLeftNoData1 = false;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/tenantDailyAvgDrivingDuration',
                data: this.queryData
            }).then((res) => {
                this.chartLeftLoading1 = false;
                if (res.code == 200) {
                    let durationData = res.data;
                    if (durationData.length < 1) {
                        this.chartLeftNoData1 = true;
                        return;
                    }
                    this.drivingDuration = durationData.map((item) => {
                        return {
                            name: item.tenantName,
                            duration: item.avgDrivingDuration
                        };
                    });
                    this.drivingDuration.forEach((item) => {
                        item.ratio = item.duration / 24;
                    });
                } else {
                    this.chartLeftNoData1 = true;
                }
            });
        },
        // 车队日均驾驶里程
        getTenantDailyAvgDrivingMileage() {
            this.chartLeftLoading2 = true;
            this.chartLeftNoData1 = false;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/usageRateTenant',
                data: this.queryData
            }).then((res) => {
                this.chartLeftLoading2 = false;
                if (res.code == 200) {
                    let mileageData = res.data;
                    if (mileageData.length < 1) {
                        this.chartLeftNoData1 = true;
                        return;
                    }
                    this.fleetAverageDailyMileageData = mileageData.map((item) => {
                        return {
                            label: item.tenantName,
                            usageRate: item.usageRate
                        };
                    });
                } else {
                    this.chartLeftNoData1 = true;
                }
            });
        },
        // 车辆日均驾驶里程
        getVehiclesDailyAvgDrivingMileage() {
            this.chartRightLoading2 = true;
            this.chartRightNoData2 = false;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/vehiclesDailyAvgDrivingMileage',
                data: this.queryData
            }).then((res) => {
                this.chartRightLoading2 = false;
                if (res.code == 200) {
                    let mileageData = res.data;
                    if (mileageData.length < 1) {
                        this.chartRightNoData2 = true;
                        return;
                    }
                    this.dailyVehicleMileageData = mileageData.map((item) => {
                        return {
                            label: item.tenantName,
                            avgMileage: item.avgMileage,
                            plateNo: item.plateNo
                        };
                    });
                } else {
                    this.chartRightNoData2 = true;
                }
            });
        },
        // 租户离线情况
        getOfflineRateTenant() {
            this.chartRightLoading0 = true;
            this.chartRightNoData0 = false;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/offlineRateTenant',
                data: this.queryData
            }).then((res) => {
                this.chartRightLoading0 = false;
                if (res.code == 200) {
                    let chartData = res.data;
                    if (chartData.length < 1) {
                        this.chartRightNoData0 = true;
                        return;
                    }

                    // 提取x轴数据（从第一个tenant的distributionVos中获取所有时间）
                    let xAxisData = chartData[0].distributionVos.map((item) => {
                        // 分割日期字符串，取后两部分并拼接
                        const [year, month, day] = item.repTime.split('-');
                        return `${month}-${day}`;
                    });

                    // 转换系列数据
                    let seriesData = chartData.map((tenant) => {
                        return {
                            name: tenant.tenantName,
                            data: tenant.distributionVos.map((item) => item.ratio)
                        };
                    });

                    this.loadChartsright0(xAxisData, seriesData);
                } else {
                    this.chartRightNoData0 = true;
                }
            });
        },
        loadChartsright0(xAxisData, seriesData) {
            let colors = ['#D6D260', '#1ED6FF', '#268AFF', '#d500f9', '#64ffda'];
            let chartDom = document.getElementById('chartRightLine');
            this.chartRight0 = echarts.init(chartDom, null, { renderer: 'svg' });
            let option = {
                textStyle: {
                    fontFamily: 'PingFang Regular'
                },
                legend: {
                    data: seriesData.map((s) => s.name),
                    textStyle: { color: '#fff', fontSize: remToPx(0.14) },
                    top: 5,
                    itemWidth: 8, // 图标宽度（默认25px）
                    itemHeight: 8, // 图标高度（默认14px）
                    itemGap: 5, // 图标与文字之间的间距（默认10px）

                    formatter: function (name) {
                        // 限制显示的最大字符数（根据宽度估算）
                        const maxLength = 4;
                        if (name.length > maxLength) {
                            return name.substring(0, maxLength) + '...';
                        }
                        return name;
                    },
                    // 鼠标悬停时显示完整文本（使用富文本配置tooltip）
                    tooltip: {
                        show: true,
                        formatter: function (params) {
                            // params为当前鼠标指向的图例项数据
                            return params.name;
                        }
                    }
                },
                tooltip: {
                    trigger: 'axis',

                    // 可选：添加边框和背景色增强可见性
                    textStyle: {
                        color: '#fff',
                        fontSize: remToPx(0.14)
                    },
                    backgroundColor: 'rgba(8, 32, 69, 0.9)',
                    borderColor: '#1E90FF',
                    borderWidth: 1,
                    confine: true
                },
                grid: {
                    top: '30%',
                    left: '13%',
                    right: '6%',
                    bottom: '12%'
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        color: '#fff',
                        fontSize: remToPx(0.11)
                    },
                    data: xAxisData
                },
                yAxis: {
                    name: '单位：%',
                    nameLocation: 'end',
                    axisLabel: {
                        color: '#fff',
                        fontSize: remToPx(0.14)
                    },
                    nameTextStyle: {
                        color: '#fff',
                        fontSize: remToPx(0.14)
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#2C4A7B',
                            width: 1,
                            type: 'solid'
                        }
                    }
                },
                series: seriesData.map((s, i) => ({
                    type: 'line',
                    itemStyle: {
                        color: colors[i] || '#D6D260'
                    },
                    lineStyle: {
                        width: 1.5
                    },
                    ...s
                }))
            };

            this.chartRight0.setOption(option);
        },
        // 车辆日均驾驶时长top5
        getVehiclesDailyAvgDrivingDuration() {
            this.chartLeftLoading1 = true;
            this.chartLeftNoData1 = false;
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/vehiclesDailyAvgDrivingDuration',
                data: this.queryData
            }).then((res) => {
                this.chartLeftLoading1 = false;
                if (res.code == 200) {
                    let durationData = res.data;

                    if (durationData.length < 1) {
                        this.chartLeftNoData1 = true;
                        return;
                    }

                    this.carDrivingDuration = durationData.map((item) => {
                        return {
                            name: item.tenantName,
                            duration: item.avgDrivingDuration,
                            plateNo: item.plateNo
                        };
                    });
                    this.carDrivingDuration.forEach((item) => {
                        item.ratio = item.duration / 24;
                    });
                } else {
                    this.chartLeftNoData1 = true;
                }
            });
        },
        loadChartsCenter0() {
            let _this = this;
            // 初始化 ECharts 实例
            this.centerChart0 = echarts.init(document.getElementById('centerChart0'));

            // 配置项
            const option = {
                grid: {
                    left: '5px',
                    transformOrigin: 'center center'
                },
                series: [
                    {
                        type: 'gauge',
                        center: ['50%', '75%'],
                        radius: '73%',
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 240,
                        splitNumber: 5,
                        pointer: {
                            icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
                            length: '75%',
                            width: 8,
                            offsetCenter: [0, '0%']
                        },
                        axisLine: {
                            roundCap: false,
                            lineStyle: {
                                width: 9,
                                color: [
                                    ['1', '#5BC2C9'] // 进度条颜色（原蓝色）
                                ]
                            }
                        },
                        progress: {
                            show: true,
                            roundCap: false,
                            width: 9
                        },
                        itemStyle: {
                            color: '#2F82FA',
                            shadowBlur: 10,
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        },
                        axisTick: {
                            splitNumber: 2,
                            lineStyle: {
                                width: 8,
                                color: '#1D4D8B'
                            }
                        },
                        splitLine: {
                            show: false,
                            length: 12,
                            lineStyle: {
                                width: 3,
                                color: '#999'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            fontSize: 12,
                            distance: -35,
                            rotate: 'tangential',
                            formatter: function (value) {
                                switch (value) {
                                    case 0:
                                        return '0';
                                    case 48:
                                        return '20';
                                    case 96:
                                        return '40';
                                    case 144:
                                        return '60';
                                    case 192:
                                        return '80';
                                    case 240:
                                        return '100';
                                }
                                return '0';
                            }
                        },
                        detail: {
                            show: false
                        },
                        data: [
                            {
                                value: 100 // 初始值
                            }
                        ]
                    }
                ]
            };
            // 使用配置项显示图表
            this.centerChart0.setOption(option);

            // 计算目标速度对应的仪表盘值（根据刻度映射关系）
            // 仪表盘上60对应144，35对应约84（根据刻度比例计算）
            function speedToGaugeValue(speed) {
                // 仪表盘刻度映射：20 → 48，40 → 96，60 → 144，即1单位实际速度 = 2.4仪表盘值
                return speed * 2.4;
            }

            // 设置速度范围：35-60
            const minSpeed = 35;
            const maxSpeed = 80;
            let currentValue = speedToGaugeValue((minSpeed + maxSpeed) / 2); // 初始值设为中间值

            // 每800毫秒更新一次指针位置
            setInterval(function () {
                // 生成35-60之间的随机速度
                const randomSpeed = minSpeed + Math.random() * (maxSpeed - minSpeed);
                // 转换为仪表盘对应的数值
                currentValue = speedToGaugeValue(randomSpeed);

                _this.centerChart0.setOption({
                    series: [
                        {
                            data: [
                                {
                                    value: currentValue
                                }
                            ]
                        }
                    ]
                });
            }, 800);
        },
        loadChartsCenter1() {
            let _this = this;
            // 初始化 ECharts 实例
            this.centerChart1 = echarts.init(document.getElementById('centerChart1'));

            // 配置项
            const option = {
                grid: {
                    left: '5px',
                    transformOrigin: 'center center'
                },
                series: [
                    {
                        type: 'gauge',
                        center: ['50%', '75%'],
                        radius: '73%',
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 240,
                        splitNumber: 5,
                        pointer: {
                            icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
                            length: '75%',
                            width: 8,
                            offsetCenter: [0, '0%']
                        },
                        axisLine: {
                            roundCap: false,
                            lineStyle: {
                                width: 9,
                                color: [
                                    ['1', '#5BC2C9'] // 进度条颜色（原蓝色）
                                ]
                            }
                        },
                        progress: {
                            show: true,
                            roundCap: false,
                            width: 9
                        },
                        itemStyle: {
                            color: '#2F82FA',
                            shadowBlur: 10,
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        },
                        axisTick: {
                            splitNumber: 2,
                            lineStyle: {
                                width: 8,
                                color: '#1D4D8B'
                            }
                        },
                        splitLine: {
                            show: false,
                            length: 12,
                            lineStyle: {
                                width: 3,
                                color: '#999'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            fontSize: 12,
                            distance: -35,
                            rotate: 'tangential',
                            formatter: function (value) {
                                switch (value) {
                                    case 0:
                                        return '0';
                                    case 48:
                                        return '20';
                                    case 96:
                                        return '40';
                                    case 144:
                                        return '60';
                                    case 192:
                                        return '80';
                                    case 240:
                                        return '100';
                                }
                                return '0';
                            }
                        },
                        detail: {
                            show: false
                        },
                        data: [
                            {
                                value: 100 // 初始值
                            }
                        ]
                    }
                ]
            };
            // 使用配置项显示图表
            this.centerChart1.setOption(option);

            // 计算目标速度对应的仪表盘值（根据刻度映射关系）
            // 仪表盘上60对应144，35对应约84（根据刻度比例计算）
            function speedToGaugeValue(speed) {
                // 仪表盘刻度映射：20 → 48，40 → 96，60 → 144，即1单位实际速度 = 2.4仪表盘值
                return speed * 2.4;
            }

            // 设置速度范围：35-60
            const minSpeed = 20;
            const maxSpeed = 70;
            let currentValue = speedToGaugeValue((minSpeed + maxSpeed) / 2); // 初始值设为中间值

            // 每800毫秒更新一次指针位置
            setInterval(function () {
                // 生成35-60之间的随机速度
                const randomSpeed = minSpeed + Math.random() * (maxSpeed - minSpeed);
                // 转换为仪表盘对应的数值
                currentValue = speedToGaugeValue(randomSpeed);

                _this.centerChart1.setOption({
                    series: [
                        {
                            data: [
                                {
                                    value: currentValue
                                }
                            ]
                        }
                    ]
                });
            }, 700);
        },
        switchType(type) {
            this.$emit('switchType', type);
        },
        goBack() {
            this.$router.push({
                path: '/vehicle/vehicleManage'
            });
        },
        currentTime() {
            this.formatDateTimer = setInterval(this.formatDate, 1000);
        },
        formatDate() {
            let date = new Date();
            let year = date.getFullYear(); // 年
            let month = date.getMonth() + 1; // 月
            let day = date.getDate(); // 日
            let week = date.getDay(); // 星期
            let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            let hour = date.getHours(); // 时
            hour = hour < 10 ? '0' + hour : hour; // 如果只有一位，则前面补零
            let minute = date.getMinutes(); // 分
            minute = minute < 10 ? '0' + minute : minute; // 如果只有一位，则前面补零
            let second = date.getSeconds(); // 秒
            second = second < 10 ? '0' + second : second; // 如果只有一位，则前面补零
            this.nowDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        },
        clickMenu(item) {
            clearInterval(this.timer);
            this.mapVisible = this.$route.path != '/Home' ? false : true;
            this.$router.push({
                path: item.linkage
            });
        },
        // 获取上一个月月份
        setMonth() {
            let tmpMonth = new Date().getMonth();
            tmpMonth = tmpMonth == 0 ? 12 : tmpMonth;
            return tmpMonth;
        }
    },
    destroyed() {
        if (this.formatDateTimer) {
            clearInterval(this.formatDateTimer); // 在Vue实例销毁前，清除时间定时器
        }
    }
};
</script>
<style lang="less" scoped>
.homePage {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
    color: #fff;
    line-height: 1;
    z-index: 5;
    overflow: hidden;
    background: linear-gradient(180deg, #001530 0%, #071b46 100%);
    padding: 0.2rem;
    .homeTab {
        width: 100%;
        height: 0.75rem;
        margin-bottom: 0.25rem;
        text-align: center;
        background: url(../../../public/images/home/topBgc.png) no-repeat;
        background-size: 101% 100%;
        background-position: center;
        letter-spacing: 2px;
        position: relative;

        .homeTitle {
            width: 7.05rem;
            line-height: 0.7rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-weight: 400;
            font-size: 0.4rem;
            font-family: YouSheBiaoTiHei;
            letter-spacing: 10px;
            text-shadow: 0px 2px 8px rgba(17, 20, 22, 0.31), 0px 0px 46px rgba(46, 174, 255, 0.63);
        }

        .auxiliaryScreen {
            width: 400px;
            height: 30px;
            position: absolute;
            top: 0.5rem;
            right: 0.47rem;
            z-index: 9;

            .closeBtn {
                font-size: 0.26rem;
                position: absolute;
                right: -0.3rem;
                cursor: pointer;
                top: 50%;
                transform: translateY(-50%);
            }
            .msgIcon {
                width: 0.2rem;
                height: 0.24rem;
                background: url(../../../public/images/home/msg.png) no-repeat;
                background-size: 100% 100%;
                position: relative;
                cursor: pointer;
            }
            .msgHot::before {
                content: '';
                display: inline-block;
                width: 7px;
                height: 7px;
                background: red;
                position: absolute;
                top: -1px;
                right: -2px;
                border-radius: 50%;
            }
            .msg-table {
                width: 620px;
                position: absolute;
                top: 30px;
                right: 0;
                margin-top: 5px;
                .msgList {
                    width: 506px;
                    background: rgba(65, 159, 255, 0.2);
                    border: 1px solid #2d7cc6;
                    position: relative;
                    .cover {
                        width: 506px;
                        height: 140px;
                        position: absolute;
                    }
                    .tableHeader {
                        height: 32px;
                        line-height: 32px;
                        background: rgba(65, 159, 255, 0.3);
                    }
                    .bodyBox {
                        height: 130px;
                        overflow-y: auto;
                        .tableBody {
                            height: 32px;
                            line-height: 32px;
                        }
                    }
                }
                .typeUl {
                    width: 106px;
                    padding: 6px 8px;
                    background: rgba(65, 159, 255, 0.3);
                    border-radius: 4px;
                    border: 1px solid #2d7cc6;
                    li {
                        height: 30px;
                        line-height: 30px;
                        margin-bottom: 5px;
                        cursor: pointer;
                    }
                    li:hover {
                        background: linear-gradient(269deg, rgba(32, 160, 249, 0.3) 0%, rgba(32, 160, 249, 0.8) 50%, rgba(32, 160, 249, 0.3) 100%);
                        border-radius: 3px;
                    }
                    .activeLi {
                        background: linear-gradient(269deg, rgba(32, 160, 249, 0.3) 0%, rgba(32, 160, 249, 0.8) 50%, rgba(32, 160, 249, 0.3) 100%);
                        border-radius: 3px;
                    }
                    li:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            // .timeContainer {
            //     margin-right: 40px;
            //     position: relative;
            //     top: -0.05rem;
            //     text-align: right;
            //     color: #cdd6e3;
            //     font-family: AlibabaPuHuiTi3;
            //     font-size: 18px;
            //     .time {
            //         font-size: 0.18rem;
            //         font-weight: 400;
            //         margin-bottom: 0.05rem;
            //     }
            //     .date {
            //         font-size: 0.1rem;
            //     }
            // }
            // .timeContainer::before {
            //     content: '';
            //     display: inline-block;
            //     width: 2px;
            //     height: 20px;
            //     background: red;
            //     position: absolute;
            //     right: -20px;
            //     top: 50%;
            //     transform: translateY(-50%);
            //     background: #9dc5e8;
            // }
            .dimension {
                position: absolute;
                top: 50%;
                // left: -150px;
                transform: translateY(-50%);
                font-size: 0.16rem;
                // width: 200px;
                right: 5px;
                color: #cdd6e3;
            }
            .dimension::before {
                content: '';
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #0f9efc;
                position: absolute;
                left: -20px;
                top: 50%;
                transform: translateY(-50%);
            }
            // .dimension::after {
            //     content: '';
            //     display: inline-block;
            //     width: 2px;
            //     height: 120%;
            //     background: #9dc5e8;
            //     position: absolute;
            //     right: 0px;
            //     top: 50%;
            //     transform: translateY(-50%);
            // }
        }

        .close_btn {
            position: absolute;
            right: 0px;
            top: 3px;
            font-size: 0.28rem;
            color: #fff;
            cursor: pointer;
            z-index: 6;
        }
    }
    .module_wrap {
        width: 100%;
    }
    .hideChart {
        // border: 1px solid red;
        .borderTop {
            color: transparent;
            background: none;
        }
    }
    .chartBoxBorder {
        position: relative;
        margin-bottom: 0.2rem;
        border-bottom: 1px solid #1059a7;
        border-left: 1px solid;
        border-right: 1px solid;
        border-image: linear-gradient(to bottom, #051733, #0b5bae) 1;
        .wrapChart {
            height: calc(100% - 0.4rem);
        }
        .null_data_chart {
            position: absolute;
            left: 50%;
            top: 40%;
            transform: translate(-50%, -50%);
        }
    }
    .chartBoxBorder::before {
        content: '';
        display: inline-block;
        position: absolute;
        left: -1px;
        bottom: -1px;
        width: 6px;
        height: 2px;
        background: #00eaff;
        border-radius: 0px 0px 0px 0px;
    }
    .chartBoxBorder::after {
        content: '';
        display: inline-block;
        position: absolute;
        right: -1px;
        bottom: -1px;
        width: 6px;
        height: 2px;
        background: #00eaff;
        border-radius: 0px 0px 0px 0px;
    }

    .borderTop {
        width: 100%;
        height: 0.3rem;
        max-height: 30px;
        line-height: 0.3rem;
        font-size: 0.18rem;
        background: url(../../../public/images/home/borderHot.png) no-repeat;
        background-size: 100% 100%;
        // position: absolute;
        // left: 0;
        // top: 0;
        text-align: left;
        padding-left: 0.45rem;
        font-family: PingFang SC;
        position: relative;
        span {
            font-size: 0.14rem;
        }
        .more {
            position: absolute;
            right: 8px;
            font-size: 0.12rem;
            color: #97caff;

            // color: #fff;
            cursor: pointer;
            padding-right: 10px;
            i {
                position: absolute;
                color: #97caff;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
        .moreBtn {
            position: absolute;
            right: 4px;
            // font-size: 0.12rem;
            color: #fff;
            cursor: pointer;
        }
    }
    .bottomChart {
        width: 100%;
        height: 2.2rem;
        box-sizing: border-box;
        padding: 0 10px;

        position: absolute;
        bottom: 0;
        z-index: 99;

        display: flex;
        justify-content: space-between;
        left: 0;
        .leftBox,
        .rightBox {
            display: inline-block;
            width: 49.7%;
            .borderTop {
                background: url(../../../public/images/home/groupBottom.png) no-repeat;
                background-size: 101% 100%;
                // background-position: center;
            }

            .rankChart {
                padding-top: 0.2rem;
                display: flex;
                // justify-content: space-around;
                margin: 0 10px;

                .dashboard {
                    flex: 1;
                    margin: 0 5px;
                    min-width: 0.82rem;
                    height: 1.2rem;
                    margin-bottom: 12px;
                    position: relative;
                    .dashIcon {
                        width: 0.9rem;
                        height: 0.9rem;
                        position: absolute;
                        left: 50%;
                        top: 0;
                        transform: translateX(-50%);
                        img {
                            position: absolute;
                        }
                        .titleBox {
                            top: 50%;
                        }
                        .dashTitle,
                        .dashSubTitle {
                            text-align: center;
                        }
                        .dashTitle {
                            margin-bottom: 0.03rem;
                            font-family: AlibabaPuHuiTi3;
                            font-weight: normal;
                            font-size: 0.2rem;
                        }
                        .dashSubTitle {
                            font-family: PingFang SC;
                            font-weight: 400;
                            font-size: 0.12rem;
                            color: rgba(255, 255, 255, 0.4);
                        }
                    }
                    .dashBottom {
                        width: 1.3rem;
                        height: 0.27rem;
                        padding: 0 2px;
                        text-align: center;
                        line-height: 0.27rem;
                        background: rgba(155, 213, 255, 0.15);
                        border-bottom: 2px solid #6698cc;
                        letter-spacing: 1.5px;
                        margin-top: 7px;
                        position: absolute;
                        left: 50%;
                        bottom: 0;
                        font-size: 0.17rem;
                        transform: translateX(-50%);
                    }
                }
                .dashboard:first-child {
                    margin-left: 0;
                }

                .dashboard:last-child {
                    margin-right: 0;
                }
            }
        }
        .rightBox {
        }
    }
}
.largeContent {
    top: 0 !important;
    bottom: 0;
    left: 0 !important;
    right: 0;
    transition: none !important;

    min-width: 1080px;
    position: fixed;
    overflow: auto;
    padding: 0 10px;
    .close_btn {
        position: absolute;
        right: 5px;
        top: 5px;
        font-size: 0.24rem;
        color: #fff;
        cursor: pointer;
        z-index: 6;
    }
}

.miniTitle {
    font-size: 10px;
    letter-spacing: 1px;
    font-style: italic;
}
.layRow,
.layCol {
    position: relative;
    height: calc(100vh - 1rem);
}
.chart_left,
.chart_right {
    width: 100%;
    height: 100%;
    // position: absolute;
    // top: 0.9rem;
    // bottom: 0.3rem;
    // left: 0;
    // z-index: 50;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
}
.chart_left {
    // left: 10px;
}
.chart_right {
    // left: auto;
    // right: 10px;
    // top: 0.8rem;
}
.left_title,
.right_title {
    color: #fff;
    width: 99%;
    height: 0.32rem;
    line-height: 0.32rem;
    text-align: center;
    background: url(../../../public/images/msi/title_box.png) no-repeat;
    background-size: 100% 100%;
    font-size: 0.18rem;
    margin: 0 auto;
}
.right_title {
    margin-top: 0.3rem;
}
.left_title span,
.right_title span {
    font-size: 12px;
}
.now_date {
    color: #30fbfe;
    width: 100%;
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
}
</style>
<style lang="less" scoped>
.left0,
.left1,
.right0,
.right1 {
    height: 35%;
}
.left2,
.right2,
.centerCharts {
    height: 24%;
}

.left1,
.right1 {
    #chart_top {
        .el-row {
            height: 0.26rem;
            margin-bottom: 0.26rem;
            display: flex;
            align-items: center;
            .fleetName {
                font-family: PingFang Regular;
                font-size: 0.14rem;
                max-width: 0.99rem;
            }
            .fleetDuration {
                font-family: PingFang Regular;
                font-size: 0.14rem;
            }
            /* 进度条容器 */
            .progressContainer {
                width: 100%; /* 容器宽度 */
                height: 8px; /* 容器高度 */
                background: #1a3971; /* 背景颜色（蓝色） */
                border-radius: 10px; /* 圆角 */
                overflow: hidden; /* 隐藏超出部分 */
                box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3); /* 内部阴影 */

                /* 进度条 */
                .progressBar {
                    height: 100%; /* 进度条高度 */
                    background-color: #07baf2; /* 进度条颜色（红色） */
                    width: 0; /* 初始宽度为 0，通过 JavaScript 动态设置 */
                    border-radius: 10px; /* 圆角 */
                    transition: width 1s ease; /* 过渡动画 */
                }
            }
        }
        .el-row:first-child {
            margin-top: 0.3rem;
        }
    }
}

.left2 {
    overflow: hidden;
    .timeTop5 {
        height: calc(100% - 0.3rem);
        .specialEffects {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .wrapChartRadius {
                width: 1.6rem;
                height: 1.6rem;
                background: url(../../../public/images/home/radius.png);
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                animation: rotateClockwise 40s linear infinite;
                .wrapChartRadius1 {
                    width: 0.96rem;
                    height: 0.96rem;
                    background: url(../../../public/images/home/radius1.png);
                    background-size: 100% 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    animation: counterRotateParent 40s linear infinite;
                    .wrapChartRadius2 {
                        width: 0.3rem;
                        height: 0.3rem;
                        background: url(../../../public/images/home/radius2.png);
                        background-size: 100% 100%;
                        animation: rotateFunnel 10s linear infinite;
                    }
                }
            }
        }
    }
}
.ranking {
    .el-row {
        height: 0.17rem;
        margin-bottom: 0.13rem;
        display: flex;
        align-items: center;
        .medalHot {
            width: 0.18rem;
            height: 0.18rem;
            line-height: 0.18rem;
        }
        .el-col {
            font-size: 0.12rem;
            font-family: PingFang SC;
        }
    }
    .el-row:first-child {
        margin-top: 0.25rem;
    }
}
.centerLayCol {
    height: calc(100vh - 3.4rem);
    .mapBtnGroups {
        margin-left: 0.2rem;
        background: #0f3679;
        border-radius: 0.04rem;
        display: inline-block;
        position: absolute;
        top: 20px;
        z-index: 999;
        li {
            float: left;
            padding: 0.08rem;
            display: inline-block;
            cursor: pointer;
            border-radius: 0.04rem;
            letter-spacing: 0.02rem;
            font-size: 0.17rem;
        }
        li:hover {
            background: #0f9efc;
        }
        .activeLi {
            background: #0f9efc;
        }
        .remark {
            width: 100%;
            position: absolute;
            bottom: -0.3rem;
            left: 0;
            z-index: 99;
        }
    }
    .chinaMap {
        height: 72.1%;
        margin-bottom: 0.2rem;
    }
}

.right2 {
    .day_table {
        padding: 0.1rem 0.16rem;
        .tableHeader {
            height: 0.27rem;
            line-height: 0.27rem;
            background: #15356c;
            color: #e4f3ff;
            .el-col {
                text-align: center;
            }
        }
        .tableBody {
            background: #0b2b64;
            color: #e4f3ff;
            height: 0.28rem;
            line-height: 0.28rem;
            .el-col {
                text-align: center;
                position: relative;
                .tableIcon {
                    width: 0.07rem;
                    height: 0.16rem;
                    position: absolute;
                    left: 0px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
        .tableBodyEven {
            background: #15356c;
            color: #e4f3ff;
        }
    }
}

.medalHot {
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.24rem;
    text-align: center;
}
.medalHot1 {
    background: url(../../../public/images/home/d1.png) no-repeat;
    background-size: 100% 100%;
}
.medalHot2 {
    background: url(../../../public/images/home/d2.png) no-repeat;
    background-size: 100% 100%;
}
.medalHot3 {
    background: url(../../../public/images/home/d3.png) no-repeat;
    background-size: 100% 100%;
}
.medalHot4 {
    background: url(../../../public/images/home/d4.png) no-repeat;
    background-size: 100% 100%;
}
.medalHot5 {
    background: url(../../../public/images/home/d4.png) no-repeat;
    background-size: 100% 100%;
}

/* 顺时针旋转动画 */
@keyframes rotateClockwise {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* 抵消父元素旋转的动画 */
@keyframes counterRotateParent {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(-360deg);
    }
}

/* 漏斗自身的逆时针旋转（无停顿） */
@keyframes rotateFunnel {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(-360deg);
    } /* 逆时针旋转360度 */
}

@media screen and (max-height: 480px) {
    .times_top li div {
        margin-top: 0.8rem;
    }
}
@media screen and (max-height: 380px) {
    .times_top li div {
        margin-top: 1.2rem;
    }
}

/* 去除加载遮罩的白色背景 */
/deep/ .el-loading-mask {
    background-color: transparent !important; /* 透明背景 */
}

/* 修改加载圆圈的颜色 */
/deep/ .el-loading-spinner .path {
    stroke: #409eff !important; /* 改为你需要的颜色，这里示例为 Element 主题蓝 */
}
</style>